import { initStore } from '../useStore';
import format from 'date-fns/format';
import { enGB } from 'date-fns/locale';
import { utcToZonedTime } from 'date-fns-tz';

const configStore = () => {
  const actions = {
    CLEAR_SELECTION: (curState) => {
      return {
        ...curState,
        selectedDate: null,
        selectedTime: null,
        selectedDateTime: null
      }
    }
  };
  const todayDate = new Date();
  const today = utcToZonedTime(todayDate, 'UTC');

  // const months = [0];
  // for (let i = 0; i < 12; i++) {
  //   months.push(enGB.localize.month(i, { width: 'abbreviated' }));
  // }
  // console.log('months', months);

  initStore(actions, {
    calendarType: null,
    monthChange: false,
    dateContext: today,
    today: today,
    // currentMonth: months,
    // currentDay: today.format("D"),
    // currentYear: today.format("Y"),
    selectedMonth: format(today, 'M'),
    selectedYear: format(today, 'Y'),
    selectedTime: null,
    selectedDate: null,
    selectedDateTime: null,
    modalIsOpen: true,
    submittingTime: false
  });
};

export default configStore;
